import React, {Component} from 'react';
import AudioPlayer from '../../components/AudioPlayer';
import strings from '../../strings';

import introAfterDe from '../../assets/sounds/de/nonwordRepetition/FOL-A-054.mp3';

import ReadyButton from '../../components/ReadyButton';

class PauseAfterTrial extends Component {
	constructor(props) {
		super(props);
		this.audio = introAfterDe;
	}
	render() {
		return (
			<>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{strings.nonword_intro_after_trial_1}
				</p>
				<p>{strings.nonword_intro_after_trial_2}</p>
				<p>{strings.nonword_intro_after_trial_3}</p>
				<ReadyButton
					onReadyChange={this.props.setReady}
					isAdultTest={true}
				/>
			</>
		);
	}
}

export default PauseAfterTrial;
